
<div class="row mt-5">
    <div *ngFor="let navGroup of NavGroups" class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
        <div class="nav-group card flex-grow-1">
            <div class="card-header mfp-header">
                <h5 class="mb-0">{{ navGroup.Name }}</h5>
            </div>
            <div class="card-body">
                <div class="my-2" *ngFor="let navEntry of navGroup.Entries">
                    <a class="btn d-block btn-secondary" [routerLink]="navEntry.Route">{{ navEntry.Name }}</a>
                </div>
<!--                <div class="my-2">-->
<!--                    <a class="btn d-block btn-secondary" (click)="ShowLoader=true">Load</a>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</div>

<div *ngIf="ShowLoader" class="loading-icon">
    <div class="sun"></div>
    <div class="mercury"></div>
    <div class="venus"></div>
    <div class="earth">
        <div class="moon"></div>
    </div>
    <div class="mars"></div>
</div>